import React, { useState } from "react";
import { funcionalidades } from "./list_funcionalidades_corredores";

interface Funcionalidad {
    title: string;
    content: Content;
}

interface Content {
    basico: string;
    estandar: string;
    premium: string;
}

export const FuncionalidadesCorredores = ({ activo }: { activo: boolean }) => {
    const [planHome, setPlanHome] = useState(activo);

    const handlePlanHome = () => {
        setPlanHome(!planHome);
    };
    return (
        <div className="  md:pt-10 py-5 3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6 mx-auto ">
            <div className="text-[#071829] 2xl:text-4xl xl:text-3xl md:text-2xl text-xl font-bold text-center  ">
                Optimiza la gestión de sus propiedades con herramientas creadas
                para su éxito
            </div>

            <p className="text-[#071829] 2xl:text-xl xl:text-base lg:text-base md:text-sm text-xs  mt-5 text-center   mx-auto ">
                ¿Tiene una propiedad en la playa, el campo o la ciudad y quiere
                alquilarla por días, semanas o temporadas? BluStay le brinda la
                solución perfecta.
            </p>
            <p className="text-[#071829] 2xl:text-xl xl:text-base lg:text-base md:text-sm text-xs  mt-2 mb-6 text-center  mx-auto ">
                ¿Administras propiedades para alquiler o venta? BluStay te
                ofrece una plataforma centralizada para manejar reservas,
                clientes y múltiples inmuebles con total facilidad. Ahorre
                tiempo, optimiza tu trabajo y brinda un servicio eficiente y
                profesional. <b>¡Gestiona más y complícate menos!</b>
            </p>

            <div className="text-[#071829] 2xl:text-4xl xl:text-3xl md:text-2xl text-xl font-bold text-center md:mt-14 mt-7 ">
                Compara planes y funciones
            </div>

            <div className="flex flex-col justify-center items-center gap-0.5 lg:gap-12  mx-auto mb-10 md:mb-16">
                {funcionalidades.map((funcionalidad, index: number) => (
                    <div className="w-full md:mt-14 mt-7  ">
                        <div className="flex justify-center">
                            <div className="w-2/5 text-[#0E1928] ">
                                <div className="mb-5  font-bold text-left text-xs lg:text-base">
                                    {Number(index) + 1}. {funcionalidad?.group}
                                </div>
                            </div>
                            <div className="w-1/5 text-[#0E1928] text-xs lg:text-base font-bold text-center">
                                Starter
                            </div>
                            <div className="w-1/5 text-[#0E1928] text-xs lg:text-base font-bold text-center">
                                Estándar
                            </div>
                            <div className="w-1/5 text-[#0E1928] text-xs lg:text-base font-bold text-center">
                                Premium
                            </div>
                        </div>
                        <div className=" ">
                            <div>
                                <div className="flex flex-col ">
                                    {funcionalidad?.content.map((content) => (
                                        <div className="flex flex-col">
                                            <div className="flex items-center h-14 ">
                                                <div className="w-2/5 text-xs lg:text-base font-medium text-[#0E1928]">
                                                    {content.title}
                                                </div>
                                                <div className="flex justify-center items-center w-1/5 text-[#0E1928]">
                                                    {content.content.basico ===
                                                    "Si" ? (
                                                        <div>
                                                            <svg
                                                                width="23"
                                                                height="20"
                                                                viewBox="0 0 23 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M18.8716 5.29289C19.3127 5.68342 19.3127 6.31658 18.8716 6.70711L9.83516 14.7071C9.39404 15.0976 8.67885 15.0976 8.23773 14.7071L3.71951 10.7071C3.27839 10.3166 3.27839 9.68342 3.71951 9.29289C4.16063 8.90237 4.87582 8.90237 5.31694 9.29289L9.03645 12.5858L17.2742 5.29289C17.7153 4.90237 18.4305 4.90237 18.8716 5.29289Z"
                                                                    fill="#22B672"
                                                                />
                                                            </svg>
                                                        </div>
                                                    ) : content.content
                                                          .basico === "No" ? (
                                                        <div>
                                                            <svg
                                                                width="23"
                                                                height="20"
                                                                viewBox="0 0 23 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.93921 15L17.2348 5M5.93921 5L17.2348 15"
                                                                    stroke="#EE2626"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </div>
                                                    ) : (
                                                        <div className="px-2 text-center text-xs lg:text-base">
                                                            {
                                                                content.content
                                                                    .basico
                                                            }
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="flex justify-center items-center w-1/5 text-[#0E1928]">
                                                    {content.content
                                                        .estandar === "Si" ? (
                                                        <div>
                                                            <svg
                                                                width="23"
                                                                height="20"
                                                                viewBox="0 0 23 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M18.8716 5.29289C19.3127 5.68342 19.3127 6.31658 18.8716 6.70711L9.83516 14.7071C9.39404 15.0976 8.67885 15.0976 8.23773 14.7071L3.71951 10.7071C3.27839 10.3166 3.27839 9.68342 3.71951 9.29289C4.16063 8.90237 4.87582 8.90237 5.31694 9.29289L9.03645 12.5858L17.2742 5.29289C17.7153 4.90237 18.4305 4.90237 18.8716 5.29289Z"
                                                                    fill="#22B672"
                                                                />
                                                            </svg>
                                                        </div>
                                                    ) : content.content
                                                          .estandar === "No" ? (
                                                        <div>
                                                            <svg
                                                                width="23"
                                                                height="20"
                                                                viewBox="0 0 23 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.93921 15L17.2348 5M5.93921 5L17.2348 15"
                                                                    stroke="#EE2626"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </div>
                                                    ) : (
                                                        <div className="px-2 text-center text-xs lg:text-base">
                                                            {
                                                                content.content
                                                                    .estandar
                                                            }
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="flex justify-center items-center w-1/5 text-[#0E1928]">
                                                    {content.content.premium ===
                                                    "Si" ? (
                                                        <div>
                                                            <svg
                                                                width="23"
                                                                height="20"
                                                                viewBox="0 0 23 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M18.8716 5.29289C19.3127 5.68342 19.3127 6.31658 18.8716 6.70711L9.83516 14.7071C9.39404 15.0976 8.67885 15.0976 8.23773 14.7071L3.71951 10.7071C3.27839 10.3166 3.27839 9.68342 3.71951 9.29289C4.16063 8.90237 4.87582 8.90237 5.31694 9.29289L9.03645 12.5858L17.2742 5.29289C17.7153 4.90237 18.4305 4.90237 18.8716 5.29289Z"
                                                                    fill="#22B672"
                                                                />
                                                            </svg>
                                                        </div>
                                                    ) : content.content
                                                          .premium === "No" ? (
                                                        <div>
                                                            <svg
                                                                width="23"
                                                                height="20"
                                                                viewBox="0 0 23 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.93921 15L17.2348 5M5.93921 5L17.2348 15"
                                                                    stroke="#EE2626"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </div>
                                                    ) : (
                                                        <div className="px-2 text-center text-xs lg:text-base">
                                                            {
                                                                content.content
                                                                    .premium
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <hr className="border-[#5E6075] opacity-20 mx-1 md:mx-10" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
